import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import { ActionItemStatus } from "@/store/models/clientUpdates/actionItem";
import { byNewestActionItem, canModifyActionItem, CLOSED_ACTION_ITEM_HINT, DEACTIVATED_CLIENT_HINT, formatDate, getActionItemDisplayStatus, highlightParts, isClientReadOnlyItem, NOT_OWNER_OR_ASSIGNEE_HINT, } from "../updatesHelpers";
/**
 * An update's action items on the timeline, each with a Completed tick (owner or assignee only).
 */
let UpdateActionItems = /** @class */ (() => {
    let UpdateActionItems = class UpdateActionItems extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.formatDate = formatDate;
        }
        get sortedItems() {
            return [...(this.items || [])].sort(byNewestActionItem);
        }
        hl(text) {
            return highlightParts(text, this.searchTerm);
        }
        statusOf(item) {
            return getActionItemDisplayStatus(item);
        }
        isCompleted(item) {
            return item.status === ActionItemStatus.Completed;
        }
        isClosed(item) {
            return item.status === ActionItemStatus.Closed;
        }
        isReadOnly(item) {
            return this.readOnly || isClientReadOnlyItem(item);
        }
        // A closed item is reopened on the Action Items page only
        canModify(item) {
            return !this.isReadOnly(item) && !this.isClosed(item) && canModifyActionItem(item);
        }
        completeTitle(item) {
            if (this.isReadOnly(item)) {
                return DEACTIVATED_CLIENT_HINT;
            }
            if (this.isClosed(item)) {
                return CLOSED_ACTION_ITEM_HINT;
            }
            if (!this.canModify(item)) {
                return NOT_OWNER_OR_ASSIGNEE_HINT;
            }
            return this.isCompleted(item) ? "Untick to reopen" : "Mark as completed";
        }
        // The tick shows the saved status; the refreshed timeline then shows the new one
        toggleCompleted(item) {
            if (!this.canModify(item) || this.statusBusy) {
                return;
            }
            this.$emit("set-status", { actionItemId: item.id.toString(), completed: !this.isCompleted(item) });
        }
    };
    __decorate([
        Prop({ default: () => [] }),
        __metadata("design:type", Array)
    ], UpdateActionItems.prototype, "items", void 0);
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], UpdateActionItems.prototype, "searchTerm", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdateActionItems.prototype, "statusBusy", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UpdateActionItems.prototype, "readOnly", void 0);
    UpdateActionItems = __decorate([
        Component({
            name: "UpdateActionItems",
        })
    ], UpdateActionItems);
    return UpdateActionItems;
})();
export default UpdateActionItems;
